var React = require('react');

function NavIconsAdd (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m18.81 5.18a9.64 9.64 0 1 0 0 13.64 9.64 9.64 0 0 0 0-13.64zm-.73 12.9a8.61 8.61 0 1 1 0-12.18 8.61 8.61 0 0 1 0 12.18zm-5.57-6.6v-6.7h-1v6.7h-6.74v1h6.7v6.7h1v-6.7h6.7v-1z"}));
}

NavIconsAdd.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsAdd;

NavIconsAdd.default = NavIconsAdd;
